module.exports = __webpack_public_path__ + "static/media/last-6-1.c25b3031.png";